// extracted by mini-css-extract-plugin
export var sliderRange = "_p9-2";
export var sliderRoot = "_p9-0";
export var sliderThumb = "_p9-3";
export var sliderTrack = "_p9-1";